const initialState = {
  websocket: {
    host: null,
  },
};

export default initialState;
